import initialState from '../initialState';
import * as types from './actionTypes.organization';

const initialStateObj = {
    organization: initialState.organization,
};

export default function OrganizationReducer(state = initialStateObj, action) {
    switch (action.type) {

        case types.CREATE_ORGANIZATION_REQ:
        case types.UPDATE_ORGANIZATION_REQ:
        case types.REMOVE_ORGANIZATION_REQ:
        case types.ADD_ORGANIZATION_MEMBER_REQ:
        case types.REMOVE_ORGANIZATION_MEMBER_REQ:
            return {
                ...state,
                ...{
                    isUpdating: true
                },
            };

        case types.CREATE_ORGANIZATION_OK:
        case types.UPDATE_ORGANIZATION_OK:
        case types.REMOVE_ORGANIZATION_OK:
        case types.ADD_ORGANIZATION_MEMBER_OK:
        case types.REMOVE_ORGANIZATION_MEMBER_OK:
        case types.CREATE_ORGANIZATION_ERR:
        case types.UPDATE_ORGANIZATION_ERR:
        case types.REMOVE_ORGANIZATION_ERR:
        case types.ADD_ORGANIZATION_MEMBER_ERR:
        case types.REMOVE_ORGANIZATION_MEMBER_ERR:
            return {
                ...state,
                ...{
                    isUpdating: false
                },
            };



        default:
            return state;
    }
}